/**
 * 补充中文文案（键与 partial-en 完全一致）
 */
export const partialZh: Record<string, string> = {
  "common.langShortEn": "EN",
  "common.langShortZh": "中文",

  "whitepaper.banner": "🎉 OranAI白皮书已上线！",
  "whitepaper.details": "详情",
  "whitepaper.closeAria": "关闭",

  "home.hero.subtitle": "一站式解决营销难题，全方位支持品牌增长",
  "home.hero.s1": "整合",
  "home.hero.em1": "前沿模型",
  "home.hero.s2": "、",
  "home.hero.em2": "产品矩阵",
  "home.hero.s3": "与",
  "home.hero.em3": "创意素材库",
  "home.hero.s4": "，打造",
  "home.hero.em4": "一站式营销解决方案",
  "home.hero.s5": "，赋能",
  "home.hero.em5": "全球品牌增长",
  "home.hero.s6": "。",

  "auth.error.loginFailed": "登录失败，请重试。",
  "auth.error.registerFailed": "注册失败，请重试。",
  "auth.error.passwordMismatch": "两次密码不一致",
  "auth.error.verificationRequired": "请输入验证码",
  "auth.error.emailRequired": "请输入邮箱地址",
  "auth.error.emailInvalid": "请输入有效的邮箱地址",
  "auth.error.sendCodeFailed": "发送验证码失败，请重试。",
  "auth.error.googleUrlFailed": "获取 Google 登录链接失败。",
  "auth.error.googleLoginFailed": "Google 登录失败，请重试。",
  "auth.error.resetFailed": "重置密码失败，请重试。",
  "auth.error.codeRequiredForgot": "请输入验证码",
  "auth.error.newPasswordRequired": "请输入新密码",
  "auth.error.passwordMin": "密码至少 6 位",
  "auth.error.passwordMismatchForgot": "两次输入的密码不一致",
  "auth.toast.passwordResetOk": "密码重置成功",

  "header.signOutAria": "退出登录",
  "header.signOut": "退出登录",
  "header.signIn": "登录",
  "header.accountMenuAria": "账户菜单",

  "auth.forgot.title": "忘记密码",
  "auth.label.email": "邮箱地址",
  "auth.placeholder.email": "邮箱",
  "auth.label.code": "验证码",
  "auth.placeholder.code": "验证码",
  "auth.sendCode.sending": "发送中...",
  "auth.sendCode.seconds": "s",
  "auth.sendCode": "发送验证码",
  "auth.label.newPassword": "新密码",
  "auth.placeholder.password": "密码",
  "auth.label.confirmPassword": "确认密码",
  "auth.placeholder.confirm": "确认",
  "auth.placeholder.confirmSignup": "确认密码",
  "auth.login.loggingIn": "登录中...",
  "common.or": "或",
  "auth.alreadyHaveAccount": "已有账户？",
  "auth.loginCta": "登录",
  "auth.resetting": "重置中...",
  "auth.resetPassword": "重置密码",
  "auth.terms.prefix": "继续即表示您同意我们的",
  "auth.terms.service": "服务条款",
  "auth.terms.mid": " 并确认我们的",
  "auth.terms.privacy": "隐私政策",

  "auth.signup.title": "注册账号",
  "auth.signup.submitting": "注册中...",
  "auth.signup.cta": "注册",
  "auth.alreadyHaveAccountAlt": "已有账号？",

  "auth.placeholder.inviteCode": "邀请码（选填）",

  "auth.login.title": "创建账号或登录",
  "auth.google.redirecting": "跳转中...",
  "auth.google.continue": "使用 Google 登录",
  "auth.continueEmail": "使用邮箱登录",
  "auth.login.submitting": "登录中...",
  "auth.login.submit": "登录",
  "auth.signUpLink": "注册",
  "auth.forgotLink": "忘记密码",

  "header.mega.scenarioTitle": "场景解决方案",
  "header.mega.industryTitle": "行业解决方案",
  "header.mega.platformTitle": "平台能力",
  "header.mega.productTitle": "产品矩阵",
  "header.mega.libraryTitle": "灵感素材库",

  "menu.sol.geo": "GEO",
  "menu.sol.social": "社媒营销",
  "menu.sol.email": "邮件营销",
  "menu.sol.sales": "销售客服",
  "menu.ind.beauty": "美妆快消",
  "menu.ind.electronics": "消费电子",
  "menu.ind.crossborder": "跨境出海",
  "menu.ind.data": "数据基建",
  "menu.plat.dataCenter": "数据中心",
  "menu.plat.modelLibrary": "模型库",
  "menu.plat.skills": "Skills",
  "menu.prod.dataInfra": "数据基建",
  "menu.prod.insights": "洞察中心",
  "menu.prod.strategy": "策略引擎",
  "menu.prod.contentFactory": "内容工厂",
  "menu.lib.video": "视频",
  "menu.lib.voice": "语音",
  "menu.lib.model": "模特",

  "pricing.plan.free": "免费版",
  "pricing.plan.starter": "入门版",
  "pricing.plan.basic": "基础版",
  "pricing.plan.pro": "专业版",
  "pricing.plan.enterprise": "企业版",

  "pricing.mailto.subject": "OranAI 企业版咨询",
  "pricing.mailto.body":
    "你好，我想咨询 OranAI 企业版。\n使用场景：_______\n联系方式：_______",

  "pricing.hero.title": "选择适合你的会员计划",
  "pricing.hero.subtitle": "用 OranAI 的洞察与创意能力，让增长更简单。",

  "pricing.action.contactSales": "联系销售",
  "pricing.action.currentPlan": "当前套餐",
  "pricing.action.upgradeTo": "升级为{{plan}}",
  "pricing.action.switchTo": "切换至{{plan}}",

  "pricing.plans.free.name": "免费版",
  "pricing.plans.free.desc": "注册即用，零门槛体验 AI 能力",
  "pricing.plans.free.credits": "20 积分",
  "pricing.plans.free.creditsNote": "一次性",

  "pricing.plans.starter.name": "入门版",
  "pricing.plans.starter.desc": "入门尝鲜，满足轻度生图和洞察报告需求",
  "pricing.plans.starter.price": "¥69.90",
  "pricing.plans.starter.priceSub": "/ 月",
  "pricing.plans.starter.credits": "699 积分",
  "pricing.plans.starter.creditsNote": "约溢价 17%",

  "pricing.plans.basic.name": "基础版",
  "pricing.plans.basic.desc": "进阶创作者，覆盖更高频的内容产出与分析需求",
  "pricing.plans.basic.price": "¥399.90",
  "pricing.plans.basic.priceSub": "/ 月",
  "pricing.plans.basic.credits": "3999 积分",
  "pricing.plans.basic.creditsNote": "约溢价 17%",

  "pricing.plans.pro.name": "专业版",
  "pricing.plans.pro.desc": "重度用户/工作室，满足高频报告生成与短视频渲染需求",
  "pricing.plans.pro.price": "¥1,399.90",
  "pricing.plans.pro.priceSub": "/ 月",
  "pricing.plans.pro.credits": "13999 积分",
  "pricing.plans.pro.creditsNote": "约溢价 16%",

  "pricing.plans.enterprise.name": "企业版",
  "pricing.plans.enterprise.desc": "企业客户，需签署线下合同",

  "pricing.badge.popular": "推荐",
  "pricing.enterprise.customPrice": "定制",
  "pricing.enterprise.customCredits": "定制额度",

  "pricing.cta.needMore": "套餐额度不够？",
  "pricing.cta.buyTopUp": "购买加油包",
  "pricing.section.comparison": "权益对比",
  "pricing.section.faq": "常见问题",
  "pricing.comparison.featureCol": "功能",
  "pricing.comparison.infinity": "不限",
  "pricing.quota.unlimited": "不限",

  "pricing.faq.0.q": "积分会过期吗？",
  "pricing.faq.0.a":
    "订阅赠送的积分按月清零（Use-it-or-lose-it）。系统按购买时间精确到分钟计算，例如 1 月 15 日 08:00 购买，则在 2 月 15 日 08:00 清零并重置新一月额度。充值包积分有效期为购买后一个月。",
  "pricing.faq.1.q": "是否可以随时取消订阅？",
  "pricing.faq.1.a": "可以随时取消自动续费。取消后当前周期仍可使用，到期未续费则权益降级。",
  "pricing.faq.2.q": "升级规则是什么？",
  "pricing.faq.2.a":
    "支付成功后立即切换到新套餐，并立即发放新套餐完整积分。旧套餐剩余时间不折算、不补差价、不顺延。",
  "pricing.faq.3.q": "充值包如何使用？",
  "pricing.faq.3.a": "单次支付，不绑定代扣。充值积分有效期为购买后一个月，到期清零。",
  "pricing.faq.4.q": "是否支持退款？",
  "pricing.faq.4.a": "不支持退款、不支持降级、不支持平级切换。如需特殊需求请联系销售。",

  "pricing.bottom.title": "准备好开始使用 OranAI 了吗？",
  "pricing.bottom.subscribe": "立即订阅",

  "pricing.checkout.noUrl": "未返回支付链接，请稍后重试或联系客服",
  "pricing.checkout.failed": "创建订单失败",
  "pricing.checkout.inProgress": "正在跳转支付…",
  "pricing.checkout.sameOrHigherTier": "你已是该档位或更高级会员，无需重复购买",

  "billing.checkout.success.title": "支付处理结果",
  "billing.checkout.success.loading": "正在确认订单状态…",
  "billing.checkout.success.awaitingGateway":
    "订单已创建，正在等待支付结果。若尚未在支付页完成付款，请返回继续；若已完成，请稍候同步或点击下方刷新。",
  "billing.checkout.success.awaitingAfterReturn":
    "已从支付页返回，正在等待订单确认。若需继续付款，可点击下方按钮；也可稍候刷新状态。",
  "billing.checkout.success.continuePay": "前往支付页",
  "billing.checkout.success.paidTitle": "支付成功",
  "billing.checkout.success.paidDesc": "订单已确认。订阅权益生效可能存在短暂延迟，若定价页未更新请稍后刷新。",
  "billing.checkout.success.failedTitle": "订单未成功",
  "billing.checkout.success.pendingTitle": "订单处理中",
  "billing.checkout.success.pendingDesc": "支付渠道回调可能有延迟，请稍后刷新本页或前往定价页查看权益。",
  "billing.checkout.success.missingOrderId": "缺少订单号参数。请从支付完成页返回的链接进入，或联系客服。",
  "billing.checkout.success.needLogin": "请先登录后查看订单状态。",
  "billing.checkout.success.goPricing": "前往定价页",
  "billing.checkout.success.goHome": "返回首页",
  "billing.checkout.success.refresh": "刷新状态",
  "billing.checkout.success.orderNo": "订单号",
  "billing.checkout.success.orderId": "订单 ID",

  "pricing.topUp.accessTitle": "加油包权益提示",
  "pricing.topUp.accessDesc":
    "解锁更多使用空间：订阅付费会员（入门版 / 基础版 / 专业版）后可按需购买加油包",
  "pricing.topUp.memberRequired": "请先订阅会员后再购买加油包",
  "pricing.topUp.gotIt": "我知道了",
  "pricing.topUp.dialogTitle": "购买加油包",
  "pricing.topUp.dialogDesc":
    "单次支付，不会自动续费；到账积分自购买起 1 个月有效，到期清零。",
  "pricing.topUp.oneOffLabel": "一次性补量包",
  "pricing.topUp.youReceive": "实际到账",
  "pricing.topUp.cancel": "取消",
  "pricing.topUp.purchase": "购买",

  "pricing.topup.small.name": "体验包",
  "pricing.topup.small.price": "¥800.00",
  "pricing.topup.small.credits": "8000 积分",
  "pricing.topup.small.note": "原价，无折让，适合首次体验或临时补量。",
  "pricing.topup.large.name": "基础包",
  "pricing.topup.large.price": "¥1,600.00",
  "pricing.topup.large.credits": "16000 积分",
  "pricing.topup.large.creditsOriginal": "15500",
  "pricing.topup.large.note": "到账多送 500 积分，适合日常补量。",
  "pricing.topup.super.name": "超值包",
  "pricing.topup.super.price": "¥2,400.00",
  "pricing.topup.super.credits": "24000 积分",
  "pricing.topup.super.creditsOriginal": "22500",
  "pricing.topup.super.note": "到账多送 1500 积分，适合高频创作和集中补量。",
  "pricing.topup.ultra.name": "豪华包",
  "pricing.topup.ultra.price": "¥3,200.00",
  "pricing.topup.ultra.credits": "32000 积分",
  "pricing.topup.ultra.creditsOriginal": "30000",
  "pricing.topup.ultra.note": "到账多送 2000 积分，更适合高积分需求量创作。",

  "pricing.feature.brandInsight": "品牌洞察（次数）",
  "pricing.feature.strategyPlan": "策划方案（次数）",
  "pricing.feature.imageGen": "图片生成（次数）",
  "pricing.feature.videoGen": "视频生成（次数）",
  "pricing.feature.viralMatch": "爆款视频匹配（次数）",
  "pricing.feature.videoRemix": "视频复刻（次数）",
  "pricing.feature.tkSolution": "TikTok 解决方案（次数）",

  "pricing.featureQuota.title": "可生成内容",
  "pricing.featureQuota.footerNote": "基于每月积分额度估算",

  "models.noModels": "当前筛选条件下没有可用模型。",

  "library.style": "风格",
  "library.playing": "播放中…",
  "library.paused": "已暂停",
  "library.gender": "性别",
  "library.ethnicity": "族裔",

  "business.application": "应用场景",
  "business.services": "服务能力",
  "business.platform": "平台矩阵",
  "business.knowBrand": "洞悉",
  "business.knowBrandDesc": "您是否仍对消费者真实需求、市场竞争格局缺乏精准洞察？",
  "business.buildBrand": "构建",
  "business.buildBrandDesc": "您是否面临优质内容产能不足、跨平台适配难、私域运营低效的困境？",
  "business.manageBrand": "管理",
  "business.manageBrandDesc": "您是否担忧品牌数据资产沉睡、舆情危机突发、合规风险失控？",
  "business.scaleBrand": "规模化",
  "business.scaleBrandDesc": "您是否困扰于全球营销本土化难、广告投放低效、ROI 无法精准预测？",
  "business.marketInsight": "市场洞察",
  "business.consumerInsight": "消费者洞察",
  "business.healthInsight": "健康洞察",
  "business.brandPositioning": "品牌定位",
  "business.brandStory": "品牌故事",
  "business.contentGeneration": "内容生成",
  "business.socialMedia": "社媒",
  "business.community": "社群",
  "business.dam": "数字资产",
  "business.sentiment": "舆情分析",
  "business.compliance": "合规",
  "business.customerService": "客服",
  "business.sales": "销售与客服",
  "business.seo": "GEO / SEO",
  "business.localization": "本土化与全球增长",
  "business.email": "邮件营销",
  "business.advertising": "广告投放",
  "business.trend": "趋势与收益预测",
  "business.voyaAI": "VoyaAI",
  "business.voyaAIDesc": "面向营销工作流与创意加速的 AI 原生助手。",
  "business.photoG": "PhotoG",
  "business.photoGDesc": "面向品牌级视觉与营销活动的多模态内容工作室。",
  "business.dataG": "DataG",
  "business.dataGDesc": "用于度量、归因与增长信号的数据智能层。",
  "business.apiServices": "API 服务",
  "business.apiServicesDesc": "以稳定 API 与 SLA 将 OranAI 能力接入您的技术栈。",
  "business.agency": "代理商计划",
  "business.agencyDesc": "面向代理商与工作室的联合售卖、赋能与专属成功支持。",

  "app.error.title": "出错了",
  "app.error.hint": "发生意外错误，您可以重试。",
  "app.error.retry": "重试",
  "app.error.showDetails": "查看技术详情",
  "app.error.backHome": "返回首页",

  "notFound.title": "404",
  "notFound.description": "页面不存在或已被移动。",
  "notFound.backHome": "返回首页",
};
